import template from "./device-pairing-action.component.html";

class DevicePairingActionController {
  constructor($log, $mdDialog, DevicesService, SessionsService, ToastsService) {
    'ngInject';
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.SessionsService = SessionsService;
    this.DevicesService = DevicesService;
    this.ToastsService = ToastsService;
  }

  confirmPairDevice() {
    let confirm = this.$mdDialog.confirm({
      title: 'Are you sure you want to pair this device?',
      textContent: 'Please note, if this device has previously been paired, the old pairing will be undone.',
      targetEvent: event,
      ok: 'Pair Device',
      cancel: 'Cancel'
    });
    let showPromise = this.$mdDialog.show(confirm);
    let success = () => this.onConfirmPairDevice();
    let failure = () => this.onConfirmPairCancel();
    return showPromise.then(success, failure);
  }

  onConfirmPairDevice() {
    let success = () => {
      this.ToastsService.showSuccessToast('We processed your device pairing request.');
    };
    let failure = (error) => {
      let friendlyMessage = 'We were unable to pair device. Please try again later';
      this.ToastsService.showErrorToast(friendlyMessage);
      return this.$log.error(`Pair device failure on tenant_id ${this.device.id}: ${error.status } ${error.statusText}`);
    };
    let pairPromise = this.DevicesService.pairDevice(this.device, this.pairingCode);
    return pairPromise.then(success, failure);
  }

  onConfirmPairCancel() {
    this.ToastsService.showInfoToast('We canceled your device pairing request.');
  }
}

export const DevicePairingActionComponent = {
  bindings: {
    device: '<'
  },
  template: template,
  controller: DevicePairingActionController
};

